<template>
    <div class="flexcol-fill overflow-hidden pa-3">
        <h2>Stundenplan Emil</h2>
        <v-container fluid class="text-light pa-0">
            <v-row align="center" no-gutters class="border-light border-t-sm border-b-sm border-opacity-100">
                <v-col cols="auto" class="text-center" style="width: 5rem;">
                    Woche {{ woche }}
                </v-col>
                <v-col cols="auto" class="text-center" style="width: 5rem;">
                    <v-icon icon="mdi-clock-outline"/>
                </v-col>
                <v-col v-for="t in model.tage" :key="t.tag" :class="'pt-2 pb-2 border-light border-s-sm border-opacity-25 text-center ' + (t.tag == wochentag ? 'bg-surface-lighten-1' : '')">
                    {{ t.tag }}
                </v-col>
            </v-row>
            <v-row align="center" v-for="s in model.stunden" :key="s.stunde" no-gutters class="border-light border-t-sm border-b-sm border-opacity-25">
                <v-col cols="auto" class="text-center" style="width: 5rem;">
                    {{ s.stunde }}
                </v-col>
                <v-col cols="auto" class="text-center" style="width: 5rem;">
                    {{ s.uhrzeit }}
                </v-col>
                <v-col v-for="t in model.tage" :key="t.tag" :class="'pt-2 pb-2 border-light border-s-sm border-opacity-25 text-center ' + (t.tag == wochentag ? 'bg-surface-lighten-1' : '')">
                    <div v-for="x in t.stunden.filter(f => f.stunde == s.stunde && (!f.woche || f.woche == woche))">
                        {{ x.fach }}
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'kc-timetable',
    data() {
        return {
        }
    },
    props: {
    },
    mounted() {
        const vm = this;
        vm.init();
    },
    computed: {
        woche() {
            const vm = this;
            const week = vm.$dayjs().isoWeek();
            return week % 2 === 0 ? "B" : "A";
        },
        wochentag() {
            const vm = this;
            return vm.$dayjs().format('dd');
        },
        model() {
            const vm = this;
            return vm.$store.state.stundenplan;
        }        
    },
    watch: {
    },
    methods: {
        init() {
            const vm = this;
        }
    }
}
</script>
<style lang="scss" scoped>
</style>